import { ThemeProvider, GlobalStyles } from '@mui/material';

import { Fragment } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

import { AlertSnackbarProvider, AlertSnackbar } from './components/snackbars';
import { GlobalThemeStyle } from './constants';
import { theme } from './constants/';
import NotFound from './features/NotFound';
import WebRoutes from './features/web-routes';
import UserProvider from './lib/user/user.context';

const queryClient = new QueryClient();

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Fragment>
        <GlobalStyles styles={GlobalThemeStyle} />

        <BrowserRouter>
          <QueryClientProvider client={queryClient}>
            <QueryParamProvider adapter={ReactRouter6Adapter}>
              <UserProvider>
                <AlertSnackbarProvider>
                  <div className="App">
                    <Routes>
                      {WebRoutes.map((routes) => {
                        return <Route key={routes.path} path={`${routes.path}/*`} Component={routes.component} />;
                      })}
                      <Route Component={NotFound} />
                    </Routes>
                    <AlertSnackbar />
                  </div>
                </AlertSnackbarProvider>
              </UserProvider>
            </QueryParamProvider>
          </QueryClientProvider>
        </BrowserRouter>
      </Fragment>
    </ThemeProvider>
  );
}

export default App;
